
export default function cardCarousel() {
    $('.card__spaces').slick({
        infinite: false,
        slidesToShow: 3,
        centerMode: false,
        prevArrow: $('.card-navigation__prev'),
        nextArrow: $('.card-navigation__next'),
        responsive: [
            {
                breakpoint: 900,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    dots: true,
                }
            },
            {
                breakpoint: 650,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    prevArrow: null,
                    nextArrow: null,
                    dots: true,
                }
            },
        ]
    });

}

document.addEventListener('readystatechange', () => {
        cardCarousel();
});
